export enum CompanyOfferType {
  ExternalWebsite = 0,
  Discount = 1,
  CouponCode = 2,
  Affiliate = 3,
  NoAction = 4,
  SingleSignOn = 5,
  ThirdPartyOffer = 6,
  SingleCodeOffer = 7,
  UniqueCodeOffer = 8,
}
